import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AISearchRequest, AISearchResponse } from './spotlight.types';

@Injectable({
    providedIn: 'root'
})
export class SpotlightService {

    private readonly baseUrl = environment.config.apiUrl + '/v1/ai/search';

    constructor(private _httpClient: HttpClient) {}

    /**
     * Realizar busca com IA
     */
    search(question: string): Observable<AISearchResponse> {
        const payload: AISearchRequest = { question };
        return this._httpClient.post<AISearchResponse>(this.baseUrl, payload);
    }

    /**
     * Buscar pesquisas recentes (últimas 10)
     */
    getRecentSearches(): Observable<AISearchResponse[]> {
        return this._httpClient.get<AISearchResponse[]>(`${this.baseUrl}/recent`);
    }

    /**
     * Buscar sugestões (últimas 50 bem-sucedidas)
     */
    getSuggestions(): Observable<AISearchResponse[]> {
        return this._httpClient.get<AISearchResponse[]>(`${this.baseUrl}/suggestions`);
    }
}
